"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dd791Schema = void 0;
const yup = __importStar(require("yup"));
exports.dd791Schema = yup.object().shape({
    id: yup.string().notRequired(),
    missionNo: yup.string().nullable(),
    tankerDoDAAC: yup.string().nullable(),
    missionDateAndTimeStartDate: yup.string().nullable(),
    missionDateAndTimeStartTime: yup.string().nullable(),
    missionDateAndTimeEndDate: yup.string().nullable(),
    missionDateAndTimeEndTime: yup.string().nullable(),
    tankerType: yup.string().nullable(),
    tankerNumber: yup.string().nullable(),
    fuelGrade: yup.string().nullable(),
    reFuelersNameAndGrade: yup.string().nullable(),
    quantityIssuedPoundsTotal: yup.string().nullable(),
    quantityIssuedGallonsTotal: yup.string().nullable(),
    issuesDataRows: yup.array().nullable(),
    eventId: yup.string().nullable(),
    isLocked: yup.boolean().required(),
});
